import styled from 'styled-components'
import { Flex } from '@components/atoms'

export const FormGroup = styled(Flex)`
    flex-direction : column;
`